<template>
	<button class="add-button">
		<svgicon name="plus"></svgicon>
		<div class="body-text-1" name="add-button">
			<slot></slot>
		</div>
	</button>
</template>
<script>
import '../../../components/icons/plus';
export default {};
</script>
<style lang="scss" scoped>
.add-button {
	outline: 0;
	border: 0;
	background-color: transparent;

	.body-text-1 {
		font-family: 'RobotoMedium';
		color: $primary-state;
		display: inline-block;
		vertical-align: middle;
	}

	.svg-icon {
		height: 24px;
		width: 24px;
		margin-right: 6px;
		fill: $primary-state;
		display: inline-block;
		vertical-align: middle;
	}
	@media (any-hover: hover) {
		&:hover {
			cursor: pointer;

			.body-text-1 {
				color: $hover-state;
			}

			.svg-icon {
				fill: $hover-state;
			}
		}
	}
}
</style>
